import type { DemoKey } from '../types';

export const es: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'Matemáticas · Estadística',
  'app.title': 'Estadística',
  'panel.experiment': 'Escena',
  'panel.params': 'Parámetros',

  'exp.survey-explorer.title': 'Explorador de encuestas',
  'exp.survey-explorer.desc': 'Elige una columna; la demo selecciona el resumen adecuado.',
  'exp.distribution-sculptor.title': 'Escultor de distribuciones',
  'exp.distribution-sculptor.desc': 'Arrastra puntos y observa cómo responden los estadísticos.',
  'exp.two-variable-lab.title': 'Laboratorio bivariado',
  'exp.two-variable-lab.desc': 'Dispersión, ajuste y la pregunta de la causalidad.',
  'exp.sampling-lab.title': 'Laboratorio de muestreo',
  'exp.sampling-lab.desc': 'Cómo la técnica y el tamaño influyen en la media muestral.',
  'exp.probability-diagrams.title': 'Diagramas de probabilidad',
  'exp.probability-diagrams.desc': 'Vistas de Venn y árbol para eventos compuestos.',

  'type.qualitative-nominal.label': 'Cualitativo · nominal',
  'type.qualitative-nominal.def': 'Categorías sin orden intrínseco.',
  'type.qualitative-ordinal.label': 'Cualitativo · ordinal',
  'type.qualitative-ordinal.def': 'Categorías con un orden significativo.',
  'type.qualitative-multi.label': 'Cualitativo · multivalor',
  'type.qualitative-multi.def': 'Cada observación puede tener varias etiquetas.',
  'type.quantitative-discrete.label': 'Cuantitativo · discreto',
  'type.quantitative-discrete.def': 'Números que vienen en pasos fijos.',
  'type.quantitative-continuous.label': 'Cuantitativo · continuo',
  'type.quantitative-continuous.def': 'Números medidos en escala continua.',

  'column.name.label': 'Nombre del alumno',
  'column.height_cm.label': 'Altura',
  'column.shoe_size_eu.label': 'Talla de zapato (EU)',
  'column.study_hours.label': 'Horas de estudio / semana',
  'column.test_score.label': 'Nota del examen',
  'column.sports_played.label': 'Deportes practicados',
  'column.eye_color.label': 'Color de ojos',
  'column.commute_min.label': 'Trayecto',
  'column.grade_year.label': 'Curso',
  'column.homework_effort.label': 'Esfuerzo en deberes',
  'column.ice-cream-sales.label': 'Ventas de helados',
  'column.drownings.label': 'Ahogamientos',
  'column.month.label': 'Mes',
  'column.storks.label': 'Cigüeñas',
  'column.births.label': 'Nacimientos',
  'column.country_area_km2.label': 'Superficie del país',
  'column.sleep_hours.label': 'Horas de sueño',
  'column.reaction_ms.label': 'Tiempo de reacción',

  'dataset.master-survey.label': 'Encuesta de clase',
  'dataset.master-survey.desc': '30 alumnos simulados.',
  'dataset.spurious-ice-cream-vs-drownings.label': 'Ventas de helados vs ahogamientos',
  'dataset.spurious-ice-cream-vs-drownings.desc':
    'Ambos suben y bajan con la estación. Los ahogamientos no causan las ventas de helados.',
  'dataset.spurious-storks-vs-births.label': 'Cigüeñas vs nacimientos',
  'dataset.spurious-storks-vs-births.desc':
    'Los países más grandes tienen más cigüeñas y más nacimientos. Las aves no son la causa.',
  'dataset.real-sleep-vs-reaction-time.label': 'Sueño vs tiempo de reacción',
  'dataset.real-sleep-vs-reaction-time.desc':
    'Más sueño, reacciones más rápidas. Una correlación negativa real — y un mecanismo plausible.',

  'tag.football.label': 'Fútbol',
  'tag.basketball.label': 'Baloncesto',
  'tag.volleyball.label': 'Voleibol',
  'tag.swimming.label': 'Natación',
  'tag.none.label': 'Ninguno',

  'population.gaussian.label': 'Campana de Gauss',
  'population.right-skewed.label': 'Sesgada a la derecha',
  'population.bimodal.label': 'Bimodal (con estratos)',
  'population.uniform.label': 'Uniforme',

  'venn.dice-even-or-prime.label': 'Dado: par o primo',
  'venn.class-sports-2set.label': 'Deportes (2 conjuntos)',
  'venn.class-sports-3set.label': 'Deportes (3 conjuntos)',
  'venn.custom.label': 'Personalizado',

  'tree.draw-without-replacement.label': 'Extracción sin reemplazo',
  'tree.custom.label': 'Personalizado',
  'tree.coin.heads': 'C',
  'tree.coin.tails': 'X',
  'tree.draw.start': 'Bolsa: 2 rojas, 3 azules',
  'tree.draw.red': 'Rojo',
  'tree.draw.blue': 'Azul',
  'tree.custom.start': 'Inicio',
  'tree.custom.A': 'A',
  'tree.custom.B': 'B',

  'card.histogram': 'Histograma',
  'card.cumulative': 'Frecuencia acumulada',
  'card.box': 'Diagrama de caja',
  'card.summary': 'Resumen de 5 números',
  'card.bar': 'Gráfico de barras',
  'card.mode': 'Moda',
  'card.tag-frequency': 'Frecuencia de etiquetas',
  'card.mode-tag': 'Etiqueta dominante',
  'card.empty-no-order': 'No aplica',
  'card.empty-multi': 'No aplica',
  'card.numberline': 'Recta numérica',
  'card.scatter': 'Dispersión',
  'card.description': 'Qué está pasando',
  'card.population': 'Población',
  'card.sampling-distribution': 'Medias muestrales',
  'card.venn': 'Venn',
  'card.tree': 'Árbol',
  'card.probabilities': 'Probabilidades',

  'param.dataset.label': 'Conjunto de datos',
  'param.column.label': 'Columna',
  'param.bins.label': 'Intervalos',
  'param.shape.label': 'Forma inicial',
  'param.show-mean.label': 'Mostrar media',
  'param.show-median.label': 'Mostrar mediana',
  'param.x-col.label': 'Columna X',
  'param.y-col.label': 'Columna Y',
  'param.show-regression.label': 'Línea de regresión',
  'param.show-residuals.label': 'Residuos',
  'param.show-confounder.label': 'Mostrar factor de confusión',
  'param.population.label': 'Población',
  'param.technique.label': 'Técnica',
  'param.sample-size.label': 'Tamaño muestral',
  'param.stratum.label': 'Estrato',
  'param.bias.label': 'Sesgo',
  'param.mode.label': 'Modo',
  'param.preset.label': 'Preset',
  'param.universe.label': 'Tamaño del universo',
  'param.show-prob.label': 'Mostrar probabilidades',
  'param.treat-as-numeric.label': 'Tratar como numérico',

  'stat.count': 'Recuento',
  'stat.mean': 'Media',
  'stat.median': 'Mediana',
  'stat.range': 'Rango',
  'stat.q1': 'Q1',
  'stat.q3': 'Q3',
  'stat.iqr': 'RIC',
  'stat.outliers': 'Atípicos',
  'stat.r': 'r de Pearson',
  'stat.r2': 'r²',
  'stat.slope': 'Pendiente',
  'stat.intercept': 'Intersección',
  'stat.n': 'n',
  'stat.population-mean': 'Media real',
  'stat.latest-sample-mean': 'Media muestral',
  'stat.sample-mean-spread': 'DE media muestral',
  'stat.sample-count': 'Muestras tomadas',
  'outlier.upper': 'Atípicos superiores',
  'outlier.lower': 'Atípicos inferiores',

  'region.A': 'A',
  'region.B': 'B',

  'btn.resample': 'Remuestrear',
  'btn.run-100': 'Tomar 100 muestras',
  'btn.stop': 'Detener',
  'btn.clear-history': 'Borrar historial',

  'explainer.no-order': 'Sin orden → sin acumulada, sin caja.',
  'explainer.multi-no-iqr': 'Multivalor → cuartiles / RIC no definidos.',
  'message.no-data': 'Sin datos.',
  'message.needs-quartiles': 'Se necesitan ≥4 puntos para cuartiles.',
  'message.x-zero-variance': 'X tiene varianza cero — no hay recta que ajustar.',
  'message.n-too-small': 'n demasiado pequeño.',
  'message.stratum-clamp': 'El estrato tenía menos filas de las pedidas — usadas todas.',
  'message.siblings-sum-to-one': 'Los hijos deben sumar 1.',
};
